export class InputManager {
  private isPressed = false;
  private onJumpStartCallback?: () => void;
  private onJumpReleaseCallback?: () => void;

  constructor(canvas: HTMLCanvasElement) {
    this.setupListeners(canvas);
  }

  private setupListeners(canvas: HTMLCanvasElement): void {
    canvas.addEventListener('mousedown', this.handlePressStart.bind(this));
    canvas.addEventListener('mouseup', this.handlePressEnd.bind(this));
    canvas.addEventListener('mouseleave', this.handlePressEnd.bind(this));

    canvas.addEventListener('touchstart', this.handlePressStart.bind(this));
    canvas.addEventListener('touchend', this.handlePressEnd.bind(this));
    canvas.addEventListener('touchcancel', this.handlePressEnd.bind(this));

    canvas.style.touchAction = 'none';
  }

  private handlePressStart(event: Event): void {
    event.preventDefault();

    if (this.isPressed) {
      return;
    }

    this.isPressed = true;

    if (this.onJumpStartCallback) {
      this.onJumpStartCallback();
    }
  }

  private handlePressEnd(event: Event): void {
    event.preventDefault();

    if (!this.isPressed) {
      return;
    }

    this.isPressed = false;

    if (this.onJumpReleaseCallback) {
      this.onJumpReleaseCallback();
    }
  }

  onJumpStart(callback: () => void): void {
    this.onJumpStartCallback = callback;
  }

  onJumpRelease(callback: () => void): void {
    this.onJumpReleaseCallback = callback;
  }

  isCurrentlyPressed(): boolean {
    return this.isPressed;
  }
}
